import { useState } from 'react';

function Audience({ onComplete }) {
  const [formData, setFormData] = useState({
    targetAudience: '',
    marketNeeds: '',
    demographics: {
      ageGroups: {
        kids: false,
        adults: false
      },
      genderGroups: {
        men: false,
        women: false,
        nonBinary: false,
        unisex: false
      }
    }
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      const [group, field] = name.split('.');
      setFormData(prev => ({
        ...prev,
        demographics: {
          ...prev.demographics,
          [group]: {
            ...prev.demographics[group],
            [field]: checked
          }
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onComplete(true);
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="flex items-center space-x-2 mb-6">
        <span className="text-orange-500">👥</span>
        <h2 className="text-lg font-medium">Audience</h2>
      </div>
      <p className="text-sm text-gray-600 mb-6">Defines the primary demographics and psychographics of your target market.</p>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Target audience
          </label>
          <textarea
            name="targetAudience"
            value={formData.targetAudience}
            onChange={handleChange}
            rows={4}
            placeholder="Detail the demographics, interests, purchasing habits, and any other factors that paint a picture of the individuals who are most likely to benefit from and engage with your products"
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Identifying the needs and preferences of the target market
          </label>
          <textarea
            name="marketNeeds"
            value={formData.marketNeeds}
            onChange={handleChange}
            rows={4}
            placeholder="How does the store identify the needs and preferences of its target market?"
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Demographics information
          </label>
          <p className="text-sm text-gray-500 mb-4">In a more direct way, who exactly are your customers?</p>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Age groups
              </label>
              <div className="space-x-4">
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    name="ageGroups.kids"
                    checked={formData.demographics.ageGroups.kids}
                    onChange={handleChange}
                    className="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                  />
                  <span className="ml-2 text-sm text-gray-700">Kids</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    name="ageGroups.adults"
                    checked={formData.demographics.ageGroups.adults}
                    onChange={handleChange}
                    className="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                  />
                  <span className="ml-2 text-sm text-gray-700">Adults</span>
                </label>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Gender groups
              </label>
              <div className="space-x-4">
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    name="genderGroups.men"
                    checked={formData.demographics.genderGroups.men}
                    onChange={handleChange}
                    className="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                  />
                  <span className="ml-2 text-sm text-gray-700">Men</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    name="genderGroups.women"
                    checked={formData.demographics.genderGroups.women}
                    onChange={handleChange}
                    className="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                  />
                  <span className="ml-2 text-sm text-gray-700">Women</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    name="genderGroups.nonBinary"
                    checked={formData.demographics.genderGroups.nonBinary}
                    onChange={handleChange}
                    className="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                  />
                  <span className="ml-2 text-sm text-gray-700">Non-binary</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    name="genderGroups.unisex"
                    checked={formData.demographics.genderGroups.unisex}
                    onChange={handleChange}
                    className="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                  />
                  <span className="ml-2 text-sm text-gray-700">Unisex</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="px-4 py-2 bg-[#0049ac] text-white rounded-lg hover:bg-[#0049ac]/90"
          >
            Save & Continue
          </button>
        </div>
      </form>
    </div>
  );
}

export default Audience;